import type { Socket } from 'socket.io-client';

import type { VideoRoomSignalingPort } from '@zingizi/video-room';

export function createZingiziSignalingPort(socket: Socket): VideoRoomSignalingPort {
  return {
    join(roomName: string) {
      socket.emit('join', roomName);
    },
    leave(roomName: string) {
      socket.emit('leave', roomName);
    },
    send(roomName: string, action: string, data?: unknown) {
      socket.emit('message', {
        roomId: roomName,
        message: {
          datetime: new Date().toISOString(),
          action,
          data,
        },
      });
    },
    subscribe(handler: (message: unknown) => void) {
      socket.on('message', handler);
      return () => {
        socket.off('message', handler);
      };
    },
  };
}
